var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogin28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6051 3H14.5024C13.058 2.9863 11.6672 3.54649 10.6354 4.55758C9.6031 5.56927 9.01482 6.94954 9 8.39488V13H5V26H24V13H10V8.40263C10.0128 7.22335 10.493 6.0973 11.3354 5.2718C12.1783 4.44571 13.3148 3.98826 14.495 4H14.5974C15.7766 4.01275 16.9027 4.49301 17.7282 5.33536C18.5543 6.17831 19.0118 7.31484 19 8.49503L20 8.50498C20.0144 7.05964 19.4541 5.66776 18.4424 4.63543C17.4307 3.6031 16.0505 3.01482 14.6051 3ZM6 14V25H23V14H6ZM14.5 18C13.6716 18 13 18.6716 13 19.5C13 20.3284 13.6716 21 14.5 21C15.3284 21 16 20.3284 16 19.5C16 18.6716 15.3284 18 14.5 18ZM12 19.5C12 18.1193 13.1193 17 14.5 17C15.8807 17 17 18.1193 17 19.5C17 20.8807 15.8807 22 14.5 22C13.1193 22 12 20.8807 12 19.5Z",
  fill: "currentColor"
})));
export default SvgLogin28;